module.exports = __webpack_public_path__ + "media/images/front/logo_casebook-dd1a4010da60f18e7083881841d9bd9c.png";